import * as React from "react";

import {faFacebook, faTwitter, faLinkedin}  from "@fortawesome/free-brands-svg-icons";
import {faCaretDown,
        faCaretUp,
        faFileArchive,
        faFilePdf,
        faSearch,
        faStopwatch}                        from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                    from "@fortawesome/react-fontawesome";
import {cx}                                 from "emotion";
import "./item-card.scss";

import {CountdownTimer}             from "@Common/react/countdown-timer";
import {
    ComponentLink,
    makeChain,
}                                   from "@Common/react/cst2";
import {Types}                      from "@Common/types";
import {formatDate1}                from "@Common/ui-components/format-date";
import {InformationBadge}           from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {formatMoney}                from "@Common/ui-components/language/format-money";
import {oMapToArr}                  from "@Common/utils/objects";
import {paddingLeft}                from "@Common/utils/strings";

import {KitCard}                    from "../../../common/kit-card/kit-card";
import {ItemAttributeDict,
        messageReorderDisallowed}   from "../../item-attributes";

const HEIGHT_TOOLTIP_ICON = 20

export const ItemCard = ({attributes, item, kitCollapsedState: {onChange: setKitCollapsed, value: kitCollapsed}}:{
    attributes        : ItemAttributeDict,
    item              : Types.Apis.Payloads.Next.Item.GetHistory.Item,
    kitCollapsedState : Types.Common.React.UseState.UseStateNext<number[]>,
}) => (
    <div className={cx("item-card-f7n item-card", item.transOrderStatus)} xd-qa-type="card" xd-qa-name={item.itemId}>
        <div className="main-item">
            <div className="card-left">
                <div className="thumbnail" xd-qa-type="icon" xd-qa-name="Image Preview">
                    {attributes.thumbnail ? (
                        <img src={item.thumbnail} alt={attributes.name.value} onClick={attributes.preview?.run}/>
                    ) : (
                        <img
                            src={require("../../../../../../../public/assets/NoImageAvailable.png")}
                            alt="No Image Available"
                        />
                    )}
                </div>
                {attributes.preview && <div className="bottom" onClick={attributes.preview.run}>
                    <FontAwesomeIcon key={item.itemId + "faSearch"} className="icon" icon={faSearch} xd-qa-type="icon" xd-qa-name="Search"/>
                    <div className="preview" xd-qa-type="link" xd-qa-name="Preview">{attributes.preview.label}</div>
                </div>}
            </div>
            <div className="card-middle">
                <div className="order" xd-qa-type="label" xd-qa-name="Order ID">Order ID <span xd-qa-type="text" xd-qa-name="Order ID">{item.itemId}</span></div>
                <div className="name" xd-qa-type="label" xd-qa-name="Name" title={attributes.name.value}>
                    {attributes.kit && "Kit - "}{attributes.name.value}
                </div>
                <div className="links">
                    <div className="link" xd-qa-type="link" xd-qa-name="Order Details" onClick={attributes.showDetails.run}>Order Details</div>
                    {attributes.reorder &&
                        <>
                            <div className="bar">|</div>
                            <div className="link" xd-qa-type="link" xd-qa-name="Reorder" onClick={attributes.reorder.run}>{attributes.reorder.label}</div>
                        </>
                    }
                    {attributes.reorderDisallowed &&
                        <>
                            <div className="bar">|</div>
                            <div className="link disallowed" xd-qa-type="link" xd-qa-name="Reorder" onClick={undefined}>{attributes.reorderDisallowed.label}</div>
                            {InformationBadge({
                                height: HEIGHT_TOOLTIP_ICON,
                                getTooltip: () => messageReorderDisallowed,
                                xdQaName: "scheduled campaigns disallowed"
                            })}
                        </>
                    }
                    {attributes.cancel && <>
                        <div className="bar">|</div>
                        <div
                            className={attributes.cancel.allowed
                                ? "cancel-link"
                                : "cancel-link disallowed"}
                            xd-qa-type="link"
                            xd-qa-name="Cancel Order"
                            onClick={attributes.cancel.run}
                            title={
                                attributes.cancel.allowed
                                ? (
                                    item?.scheduledDate?.date
                                    ? (
                                        "This order is scheduled to go into production on "
                                        + formatDate1(new Date(item.scheduledDate.date))
                                        + ". You may cancel at anytime prior to that date"
                                    )
                                    : "This order is not in production and can be cancelled before the timer runs out."
                                )
                                : "This order cannot be cancelled"
                            }
                        >{attributes.cancel.label} {!attributes.cancel.allowed && InformationBadge({
                            height: HEIGHT_TOOLTIP_ICON,
                            getTooltip: () => (
                                "Downloadable products cannot be cancelled. "
                                + "If you need assistance, contact us at (866) 977-3627"
                            ),
                            xdQaName: "Contact Xpressdocs"
                        })}</div>
                        {attributes.cancel.allowed && <CancelCountdown expiration={attributes.cancel.expiration}/>}
                    </>}
                </div>
                <div className="links2">

                    {item?.deliveryStatus && <div className="link-group">
                        <div className="label">{attributes.trackDeliveryStatus.label}</div>
                        {attributes.trackDeliveryStatus.run ? (
                            <a
                                className="link"
                                xd-qa-type="link"
                                xd-qa-name="Status"
                                onClick={attributes.trackDeliveryStatus.run}
                            >
                                {item.deliveryStatus}
                            </a>
                        ) : (
                            <div className="value" title={attributes.trackDeliveryStatus.message} xd-qa-type="label" xd-qa-name="Status">{item.transOrderStatus === "cancelled" ? "Cancelled" : item.deliveryStatus}</div>
                        )}
                    </div>}
                    {attributes.download && (
                            <div className="link-group">
                                <div className="label" xd-qa-type="label" xd-qa-name="Images">Images</div>
                                {
                                    attributes.downloadImagePDF ? (
                                        downloadOptions({
                                            item,
                                            pdfOption: attributes.downloadImagePDF.run,
                                            zipOption: attributes.download.run
                                        })
                                    ) : (
                                        <a
                                            className="link"
                                            xd-qa-type="link"
                                            xd-qa-name="Download"
                                            onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.download.run}
                                        >
                                            {attributes.download.label}
                                        </a>
                                    )
                                }
                            </div>
                        )
                    }
                    {attributes.downloadProof && (
                        <div className="link-group">
                            <div className="label" xd-qa-type="label" xd-qa-name="Proof">Proof</div>
                            {
                                attributes.downloadZip ? (
                                    downloadOptions({
                                        item,
                                        pdfOption: attributes.downloadProof.run,
                                        zipOption: attributes.downloadZip.run
                                    })
                                ) : (
                                    <a
                                        className="link"
                                        xd-qa-type="link"
                                        xd-qa-name={attributes.downloadProof.label}
                                        onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.downloadProof.run}
                                    >
                                        {attributes.downloadProof.label}
                                    </a>
                                )
                            }
                        </div>
                    )}
                    {attributes.downloadPhotos && (
                        <div className="link-group">
                            <div className="label" xd-qa-type="label" xd-qa-name="Photos">Photos</div>
                            <a
                                className="link"
                                xd-qa-type="link"
                                xd-qa-name="Download Photos"
                                onClick={item.deliveryStatus === "Cancelled" ? undefined : attributes.downloadPhotos.run}
                            >
                                {attributes.downloadPhotos.label}
                            </a>
                        </div>
                    )}
                    <div className="link-group">
                        <div className="label">{attributes.programName.label}</div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Program">{attributes.programName.value}</div>
                    </div>                    
                    {attributes.kit?.length > 0 && (
                        <div className="link-group">
                            <div className="label" xd-qa-type="label" xd-qa-name="Kit Components">{
                                `Kit Components (${attributes.kit.length})`
                            }</div>
                            <div className="value" xd-qa-type="label" xd-qa-name="Kit Components Link">
                                <a
                                    className="link"
                                    onClick={() => setKitCollapsed(
                                        kitCollapsed.includes(item.itemId) ? (
                                            kitCollapsed.filter((p) => p !== item.itemId)
                                        ) : (
                                            [...kitCollapsed, item.itemId]
                                        )
                                    )}
                                >{kitCollapsed.includes(item.itemId) ? (
                                    <span xd-qa-type="text" xd-qa-name="Hide">Hide</span>
                                ) : (
                                    <span xd-qa-type="text" xd-qa-name="View">Show</span>
                                )}</a>
                            </div>
                        </div>
                    )}
                    {attributes.placedBy && (
                    <div className="link-group">
                        <div className="label">{attributes.placedBy.label}</div>
                        <div className="value" xd-qa-type="label" xd-qa-name="placedBy">{attributes.placedBy.value}</div>
                    </div>)}
                    {attributes.approvedBy && (
                    <div className="link-group">
                        <div className="label">{attributes.approvedBy?.label}</div>
                        <div className="value" xd-qa-type="label" xd-qa-name="approvedBy">{attributes.approvedBy?.value}</div>
                    </div>)}
                </div>
            </div>
            <div className="card-right">
                <div className="top">
                    <div className="quantity">
                        <div className="label">Quantity</div>
                        <div className="value" xd-qa-type="label" xd-qa-name="Quantity">{item.selections.quantity}</div>
                    </div>
                    {attributes.price && <>
                        <div className="bar"></div>
                        <div className="price" xd-qa-type="label" xd-qa-name="Price">{formatMoney(attributes.price.value, {useFreeLabel:false, alwaysShowDollarSymbol:true})}</div>
                    </>}
                </div>
                {attributes.xpressLinks && (
                    <a
                        className="bottom"
                        xd-qa-type="link"
                        xd-qa-name="Xpresslinks"
                        onClick={attributes.xpressLinks.run}
                    >
                        <div className="xpress-links">
                            <img src={require("./xpress-links.png")} alt="Xpress Links" xd-qa-type="icon" xd-qa-name="Xpresslinks Icon"/>
                        </div>
                        {/* <div className="icon" xd-qa-type="icon" xd-qa-name="Facebook"><FontAwesomeIcon className="facebook" icon={faFacebook}/></div>
                        <div className="icon" xd-qa-type="icon" xd-qa-name="X"><FontAwesomeIcon className="x" icon={faTwitter}/></div>
                        <div className="icon" xd-qa-type="icon" xd-qa-name="Linkedin"><FontAwesomeIcon className="linkedin" icon={faLinkedin}/></div> */}
                    </a>
                )}
            </div>
        </div>
        {attributes.kit?.length > 0 && kitCollapsed.includes(item.itemId) &&
        <div className={cx("kit-list", {collapsed: !kitCollapsed.includes(item.itemId)})}>
            {oMapToArr(item.components).map((component: any, i) => (

                <KitCard 
                    key={i}
                    component={component} 
                    itemId={item.itemId} 
                    isPendingTransaction="false"
                    isApproval="false"
                />

            ))}
        </div>}
    </div>
);

const CancelCountdown = ({expiration}:{
    expiration  : Date,
}) => (
    makeChain<JSX.Element>()
    .then("timeLeft", (({}, next:ComponentLink<typeof CountdownTimer>) => (
        CountdownTimer({next, countdownTo: expiration})
    )))
    .then(({timeLeft}) => timeLeft.minutes < 10 && (
        <div className="cancel-field" title="This order is not in production and can be cancelled before the timer runs out.">
            <div className="icon-div"><FontAwesomeIcon className="icon" icon={faStopwatch} xd-qa-type="icon" xd-qa-name="Stop Watch"/></div>
            <div className="cancel-timer">{timeLeft.minutes >= 1 ? `${timeLeft.minutes}:${paddingLeft(timeLeft.seconds)} Left` : `${timeLeft.seconds} sec Left`}</div>
        </div>
    ))
    .run()
);

const downloadOptions = ({item, pdfOption, zipOption}) => {
    const [showActions, setShowActions] = React.useState(false)

    return (
        <div className="download" onClick={() => setShowActions(!showActions)} xd-qa-type="link" xd-qa-name="Download">
            <a>
                Download
                {<i><FontAwesomeIcon icon={showActions ? faCaretUp : faCaretDown}/></i>}
            </a>
            {
                showActions &&
                <div className="actions">
                    <a
                        className="link"
                        xd-qa-type="link"
                        xd-qa-name="PDF"
                        onClick={item.deliveryStatus === "Cancelled" ? undefined : pdfOption}
                    >
                        <i><FontAwesomeIcon icon={faFilePdf}/></i> PDF
                    </a>
                    <a
                        className="link"
                        xd-qa-type="link"
                        xd-qa-name="Zip"
                        onClick={item.deliveryStatus === "Cancelled" ? undefined : zipOption}
                    >
                        <i><FontAwesomeIcon icon={faFileArchive}/></i> Zip
                    </a>
                </div>
            }
        </div>
    )
}